import AreaTemplate from '../AreaTemplate';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'ElectricalContractor',
  name: 'Electrician Solutions Fresno — Porterville',
  description: 'Licensed electrician serving Porterville, CA. C-10 certified electrical contractor for residential and commercial electrical work in Porterville and Tulare County.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Porterville',
    addressRegion: 'CA',
    postalCode: '93257',
    addressCountry: 'US',
  },
  geo: { '@type': 'GeoCoordinates', latitude: '36.0655', longitude: '-119.0168' },
  url: 'https://electriciansolutionsfresno.com/areas/porterville',
  telephone: '+1-559-123-4567',
  priceRange: '$$',
  areaServed: { '@type': 'City', name: 'Porterville', '@id': 'https://en.wikipedia.org/wiki/Porterville,_California' },
};

const faqs = [
  {
    q: 'Do you provide electrician services in Porterville, CA?',
    a: 'Yes! Electrician Solutions Fresno serves all of Porterville, CA and South Tulare County. Our C-10 licensed electricians provide full residential, commercial, and agricultural electrical services throughout Porterville, from the foothills of the Sierra Nevada to the valley floor.',
  },
  {
    q: 'Can you handle electrical work for Porterville foothill properties?',
    a: 'Absolutely. Porterville is the gateway to Sequoia National Forest and we specialize in electrical work for foothill homes including long service runs, backup generator systems, solar installations, and whole-house rewiring for older Sierra foothills properties.',
  },
  {
    q: 'How quickly can you reach Porterville for emergencies?',
    a: 'Porterville is approximately 60 miles south-east of Fresno. We dispatch 24/7 emergency electricians to Porterville with typical response times of 60–90 minutes. For same-day scheduled work we can often accommodate same-day requests.',
  },
  {
    q: 'Do you serve commercial businesses on Main Street Porterville?',
    a: 'Yes. We handle commercial electrical work throughout the Porterville downtown and Main Street area, Henderson Ave corridor, and Porterville Marketplace. This includes tenant improvements, LED lighting retrofits, panel upgrades, and three-phase power installations.',
  },
  {
    q: 'Can you install backup power systems in Porterville?',
    a: 'Absolutely. Porterville and the Tule River area are prone to PSPS events and outages. We install whole-home generator hookups, battery backup systems, and solar-plus-battery storage to keep Porterville homes powered during outages.',
  },
  {
    q: 'What areas around Porterville do you cover?',
    a: 'We cover all of Porterville plus Springville, Terra Bella, Strathmore, Lindsay, Exeter, and rural South Tulare County properties. We serve the entire foothill and valley corridor south of Visalia.',
  },
];

const PortervillePage = () => (
  <AreaTemplate
    area="Porterville"
    areaSlug="porterville"
    state="CA"
    county="Tulare County"
    population="60,000+"
    description="Electrician Solutions Fresno delivers expert C-10 licensed electrical services throughout Porterville, CA and South Tulare County. As the gateway to Sequoia National Forest and one of the largest cities in the southern San Joaquin Valley, Porterville has diverse electrical needs spanning modern subdivisions, Sierra foothill properties, and a growing commercial sector. Our certified Porterville electricians are your trusted local electrical experts."
    neighborhoods={['Downtown Porterville', 'North Porterville', 'Henderson Ave Area', 'Porterville Marketplace', 'East Porterville', 'Springville Foothills', 'Terra Bella', 'Tule River Area']}
    nearbyAreas={[
      { name: 'Visalia', slug: 'visalia' },
      { name: 'Tulare', slug: 'tulare' },
      { name: 'Hanford', slug: 'hanford' },
      { name: 'Dinuba', slug: 'dinuba' },
      { name: 'Fresno', slug: 'fresno' },
    ]}
    faqs={faqs}
    heroImage="https://public.readdy.ai/ai/img_res/3007b9cb92e8d36fdd72ef3716d2b702.jpg"
    heroImageAlt="Licensed Electrician in Porterville CA"
    teamImage="https://readdy.ai/api/search-image?query=Professional%20electrician%20team%20in%20uniforms%20standing%20in%20front%20of%20Porterville%20California%20with%20Sierra%20Nevada%20mountains%20and%20Sequoia%20foothills%20in%20background%20golden%20afternoon%20light%20showing%20local%20expertise%20in%20South%20Tulare%20County%20electrical%20services&width=800&height=600&seq=porterville_team_001&orientation=landscape"
    teamImageAlt="Electrician Solutions team serving Porterville CA"
    schema={schema}
  />
);

export default PortervillePage;
